/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDealerInfo_seller = {
    readonly agreementStart: string | null;
    readonly sellerOrderQuantity: number | null;
    readonly analytics: {
        readonly metrics: {
            readonly responseTime: {
                readonly value: number | null;
            } | null;
        } | null;
    } | null;
    readonly tradeAssociations: ReadonlyArray<{
        readonly serviceId: string | null;
        readonly displayName: string | null;
    } | null> | null;
    readonly sellerProfile: {
        readonly establishmentYear: string | null;
    } | null;
    readonly " $refType": "PdpSharedDealerInfo_seller";
};
export type PdpSharedDealerInfo_seller$data = PdpSharedDealerInfo_seller;
export type PdpSharedDealerInfo_seller$key = {
    readonly " $data"?: PdpSharedDealerInfo_seller$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedDealerInfo_seller">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedDealerInfo_seller",
  "type": "Seller",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "agreementStart",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "sellerOrderQuantity",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "analytics",
      "storageKey": null,
      "args": null,
      "concreteType": "MCAnalytics",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "metrics",
          "storageKey": null,
          "args": null,
          "concreteType": "MCAnalyticsMetrics",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "responseTime",
              "storageKey": null,
              "args": null,
              "concreteType": "MCMetricResponseTime",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "value",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "tradeAssociations",
      "storageKey": null,
      "args": null,
      "concreteType": "TradeAssociation",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "serviceId",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "displayName",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "sellerProfile",
      "storageKey": null,
      "args": null,
      "concreteType": "SellerProfile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "establishmentYear",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = '04c2de6ee0d0fbde45416247bcb9fb86';
export default node;
